export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse prüfen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse eingeben"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain auswählen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prüfung durchführen"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niedriges Risiko"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mittleres Risiko"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hohes Risiko"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht auf der schwarzen Liste"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Andere Adresse prüfen"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PDF herunterladen"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anbieter wählen"])}
}